import { TLanguage } from 'config/tenancy';

export const GTM_IDS: Record<TLanguage, string> = {
  pt: 'GTM-PCJ7F99',
  es: 'GTM-PBXMTWW',
  'es-CR': '',
  'es-UY': 'GTM-MGMV5SRC',
};

export const GTAG_IDS: Record<TLanguage, string> = {
  pt: '',
  es: 'G-HBYNNHG40H',
  'es-CR': 'G-W9HQ47TX9M',
  'es-UY': 'G-5NP8Q9HV4E',
};
